import Directory from '../Components/directory/Directory'

function HomePage() {
  return (
    <div className="container">
      <Directory />
    </div>
  )
}

export default HomePage
